module.exports = __webpack_public_path__ + "media/images/pillar_facebook-dcc2b949494fdd4aff461fe0067fbdb0.jpg";